import apiClient from '../lib/apiClient';

// Get overtime settings (global or employee-specific)
const getOvertimeSettings = async (employeeId = null) => {
  try {
    const params = employeeId ? { employee_id: employeeId } : {};
    const result = await apiClient.get('/overtime-settings', params);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch overtime settings' };
  }
};

// Save overtime settings
const saveOvertimeSettings = async (settings, employeeId = null) => {
  try {
    const data = {
      ...settings,
      employee_id: employeeId || null
    };
    const result = await apiClient.post('/overtime-settings', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to save overtime settings' };
  }
};

// Update overtime settings
const updateOvertimeSettings = async (id, settings) => {
  try {
    const result = await apiClient.put(`/overtime-settings/${id}`, settings);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update overtime settings' };
  }
};

// Calculate overtime for attendance record
const calculateOvertime = async (attendanceRecordId, settings = null) => {
  try {
    const data = settings ? { settings } : {};
    const result = await apiClient.post(`/overtime-settings/calculate/${attendanceRecordId}`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to calculate overtime' };
  }
};

export default {
  getOvertimeSettings,
  saveOvertimeSettings,
  updateOvertimeSettings,
  calculateOvertime
};

